import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mushroom"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M7.50013 4.50018C6.52382 5.47649 6.29303 6.58597 7.00014 8.00018C7.32486 8.64962 8.3005 9.65105 9.26056 10.5448L13.4552 14.7394C14.9808 16.3783 17.2612 18.7391 19.5001 16.5002C20.8614 15.1389 21.718 13.2386 22.0001 11.2072C22.3655 8.57656 21.763 5.76305 20.0001 4.00018C16.8759 0.875981 10.6243 1.37598 7.50013 4.50018Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M5.00029 13.9994C6.97517 12.7316 9.26053 10.5445 9.26053 10.5445L13.4552 14.7392C13.4552 14.7392 11.2681 17.0245 10.0003 18.9994C9.42506 19.9581 7.53582 23.5349 4.00028 19.9994C0.46475 16.4639 4.04159 14.5746 5.00029 13.9994Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M11.0665 2.3983C11.5368 4.95842 13.8033 7.00018 16.4994 7.00018C18.238 7.00018 19.7882 6.23855 20.7961 4.97897C20.5634 4.62663 20.2984 4.29837 20.0002 4.00018C17.8318 1.83175 14.1567 1.40925 11.0665 2.3983Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M16.0213 17.0107L16.0001 17.0001C15.6963 16.8482 15.4111 16.6388 15.0001 16.2703C15.1709 13.3865 17.5735 11.0001 20.5002 11.0001C21.0202 11.0001 21.5233 11.0723 22.0002 11.2072C21.718 13.2386 20.8615 15.1388 19.5001 16.5001C18.5287 17.4716 17.4237 17.7119 16.0213 17.0107Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M11.0664 2.39844C11.5367 4.95856 13.8032 7.00032 16.4993 7.00032C18.2379 7.00032 19.7881 6.23869 20.796 4.97911M22.0001 11.2073C21.5232 11.0724 21.0201 11.0003 20.5001 11.0003C17.5734 11.0003 15.1708 13.3867 15 16.2705","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M5.00029 13.9997C6.97517 12.7319 9.26053 10.5448 9.26053 10.5448L13.4552 14.7394C13.4552 14.7394 11.2681 17.0248 10.0003 18.9997C9.42506 19.9584 7.53582 23.5352 4.00028 19.9997C0.46475 16.4641 4.04159 14.5749 5.00029 13.9997Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M7.5001 4.50018C6.52379 5.47649 6.293 6.58597 7.00011 8.00018C7.32483 8.64962 8.30029 9.65156 9.26034 10.5453L13.455 14.7399C14.9806 16.3788 17.2612 18.7391 19.5001 16.5002C20.8614 15.1389 21.718 13.2386 22.0001 11.2072C22.3654 8.57656 21.763 5.76305 20.0001 4.00018C16.8759 0.875981 10.6243 1.37598 7.5001 4.50018Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const Mushroom = Vue.extend<IconProps>({
  name: 'MushroomIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'mushroom',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Mushroom;
